const FUNCTIONS_URL = 'https://us-central1-lctf-projects.cloudfunctions.net';

async function post<T>(name: string, body: Record<string, unknown>): Promise<T> {
  const res = await fetch(`${FUNCTIONS_URL}/${name}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    throw new Error(json.error || `Request failed (${res.status})`);
  }
  return json as T;
}

export type PublicCrewOnboardPayload = {
  applicantId: string;
  slug: string;
  status: string;
  firstName: string;
  lastName: string;
  email: string;
  hasW9: boolean;
  hasPhotoId: boolean;
  formsApproved: boolean;
  agreement: {
    id: string;
    slug: string;
    status: string;
    fields: Record<string, unknown>;
    sections: Array<{ id: string; heading: string; body: string }>;
    ceoSignature: unknown;
    contractorSignature: unknown;
    signedAt?: unknown;
    signedPdfUrl?: string | null;
  } | null;
};

export async function fetchPublicCrewOnboard(slug: string) {
  return post<{ success: true; onboard: PublicCrewOnboardPayload }>('getPublicCrewOnboard', { slug });
}

export async function createContractorOnboardUploadSession(input: {
  slug: string;
  kind: 'w9' | 'id';
  fileName: string;
  contentType: string;
}) {
  return post<{
    success: true;
    sessionId: string;
    uploadUrl: string;
    maxBytes: number;
  }>('createContractorOnboardUploadSession', input);
}

export async function submitContractorOnboardForms(input: {
  slug: string;
  w9SessionId: string;
  idSessionId: string;
}) {
  return post<{ success: true }>('submitContractorOnboardForms', input);
}

export async function signPublicContractorAgreement(input: {
  slug: string;
  signedBy: string;
  dataUrl: string;
}) {
  return post<{ success: true; already?: boolean }>('signContractorAgreement', input);
}
